import HtmlElement from '../../../Elements/HtmlElement';

/**
 * JobsFilter
 */
const JobsFilter = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		JOBS_FILTER: '.jobs-filter'
	};

	/**
	 * JobsFilter
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class JobsFilter extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.sectionId = this.$element.data('section-id');

			this.$form = this.$element.find('form');
			this.$form.find('select').on('change', () => {
				this.filter();
			});

			this.$form.find('.filter-reset').on('click', (e) => {
				e.preventDefault();
				window.location.href = `${window.location.origin}${window.location.pathname}${this.sectionId ? `#${this.sectionId}` : ''}`;
			});
		}

		filter() {
			const formData = new FormData(this.$form.get(0));
			const location = formData.get('tx_igrecruitee_jobsfilter[location]');
			const department = formData.get('tx_igrecruitee_jobsfilter[department]');
			const employmentType = formData.get('tx_igrecruitee_jobsfilter[employmentType]');

			const baseUrl = `${window.location.origin}${window.location.pathname}`
			const params = new URLSearchParams();

			if (location && location.length) {
				params.append('location', location);
			}

			if (department && department.length) {
				params.append('department', department);
			}

			if (employmentType && employmentType.length) {
				params.append('employmentType', employmentType);
			}

			let url = baseUrl;

			if (params.size > 0) {
				url += `?${params.toString()}`;
			}

			if (window.location.hash) {
				url += window.location.hash;
			} else if (this.sectionId.length) {
				url += `#${this.sectionId}`;
			}

			window.location.href = url;
		}
	}

	return JobsFilter._getElements(Selector.JOBS_FILTER, JobsFilter);
})();

export default JobsFilter;
